<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Oppgjør</h2>
    </v-flex>
    <v-flex xs12 class="mb-3">
      <BooleanInput v-model="stepValues.bool.first" @update-fields="updateFields" :notSure="true"></BooleanInput>
    </v-flex>
    <div v-if="stepValues.bool.first.depositReturn.value == 0 || stepValues.bool.first.depositReturn.value == 2 || config.alwaysShow">
      <v-flex xs12 class="mb-3">
        <v-card flat>
          <v-card-text>
            <v-flex v-if="stepValues.bool.first.depositReturn.value == 0 || config.alwaysShow" xs12 class="text-center">
              <BooleanInput v-model="stepValues.bool.second" @update-fields="updateFields"></BooleanInput>
              <h4
                v-if="stepValues.bool.second.agreement.value"
              >Partene er enige om at leietager skylder utleier kr</h4>
              <h4 v-else>Partene er uenige om oppgjøret. Utleier krever dekket:</h4>
              <TextInput v-model="stepValues.textInputs" @update-fields="updateFields"></TextInput>
            </v-flex>
            <v-flex v-if="stepValues.bool.first.depositReturn.value == 0 || stepValues.bool.first.depositReturn.value == 2 || config.alwaysShow" xs12 class="text-center">
               <v-textarea
                box
                v-model="stepValues.textAreaInputs.depositComment.value"
                @input="updateFields"
                label="Kommentar"
              ></v-textarea>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </div>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";
export default {
  mixins: [step],
  computed: {
    finished: function() {
      if (!this.stepValues.bool.first.depositReturn.value) {
        if (!Boolean(this.stepValues.textInputs.sum.value)) {
          this.$emit("error", "Feltet med beløp må fylles ut");
          return false;
        }
      }
      return true;
    }
  }
};
</script>
